import {Component} from '@angular/core';
import {
  ArticleBodyDirective,
  ArticleTitleDirective,
  PolicyArticleComponent
} from "projects/soko-console-web-v2/src/app/features/support/policies/policy-article/policy-article.component";

@Component({
  selector: 'app-client-pay-out-policy-and-frequency-article',
  standalone: true,
  imports: [
    PolicyArticleComponent, ArticleTitleDirective, ArticleBodyDirective
  ],
  styleUrl: './styles/support-policy-articles-common.scss',
  template: `
    <app-policy-article>
      <span articleTitle>Client pay-out policy and frequency</span>
      <div articleBody class="body-1-regular-1">

        <section>
          <div class="heading">Client pay-out amount</div>
          <div>The client pay-out amount:</div>
            <ul>
              <li>Is the total of transaction fees and percentage rental collected for a specific month.</li>
              <li>Excludes the Nter licensing fee which gets deducted prior to processing the payment.</li>
            </ul>
        </section>

        <section>
          <div class="heading">Frequency</div>
          <div>
            All client pay-outs occur once a month within 7 working days after month-end.
          </div>
        </section>

        <section>
          <div class="heading">Authorization</div>
          <div>
            Client pay-outs are loaded to Netcash and authorised by the client as part of the weekly batch authorisation
            process.
          </div>
        </section>

      </div>
    </app-policy-article>
  `
})
export class ClientPayOutPolicyAndFrequencyArticleComponent {

}
